export enum STATUS_BOOKING {
  PENDING = 0,
  APPROVED = 1,
  REFUSED = 2,
  CANCELED_BY_CW = 3,
  CANCELED_BY_USER = 4,
  AWAITING_PAYMENT = 5,
  CANCELED_PAYMENT = 6,
}
export const STATUS_BOOKINGS_NAMES = {
  PENDING: {
    title: "Pendente",
    badge_color: "default",
  },
  APPROVED: {
    title: "Aprovado",
    badge_color: "lime_400",
  },
  REFUSED: {
    title: "Recusado",
    badge_color: "red_300",
  },
  CANCELED_BY_CW: {
    title: "Cancelado pelo CW",
    badge_color: "red_300",
  },
  CANCELED_BY_USER: {
    title: "Cancelado pelo usuário",
    badge_color: "red_400",
  },
  AWAITING_PAYMENT: {
    title: "Aguardando pagamento",
    badge_color: "outline",
  },
  CANCELED_PAYMENT: {
    title: "Pagamento cancelado",
    badge_color: "red-200",
    color: "secondary",
  },
};
